import { useCallback } from 'react';

const isValidResponseAndPageLocation = (response: any, pageLocation: any): boolean => {
  return response?.length && pageLocation?.pathname;
};

const normalizeString = (str: string) => str.toLowerCase().trim();

const getFilteredModuleData = (moduleName: string, response: any, pageLocation: any): any[] => {
  return response.filter(
    ({ module, pageURL }: any) =>
      module &&
      module === moduleName &&
      normalizeString(pageLocation.pathname) === normalizeString(pageURL.toString())
  );
};

const getPageInfoData = (filteredModuleData: any) => {
  if (!filteredModuleData.length) return;

  const [initData] = filteredModuleData;
  const imageContainer = filteredModuleData.map(({ contentImage, imageText }: any) => ({
    contentImage,
    imageText,
  }));

  return { ...initData, imageContainer };
};

export const useHelpSectionPageInfo = () => {
  return useCallback((moduleName: string, response: any, pageLocation: any) => {
    if (!isValidResponseAndPageLocation(response, pageLocation)) return;

    const filteredModuleData = getFilteredModuleData(moduleName, response, pageLocation);

    return getPageInfoData(filteredModuleData);
  }, []);
};
